import { ShimmerElementType } from "@fluentui/react";

export const shimmerWithElementGapRow = [{ type: ShimmerElementType.line }];
